import * as React from 'react';
import * as CSS from 'csstype';
import { ReactElement } from 'react';

type MoneyProps = {
    amount: number,
    currency?: string | ReactElement,
};

const Money = ({ amount, currency }: MoneyProps) => {
    const isNegative = amount < 0;
    let style: CSS.Properties = {};
    if (isNegative) {
        style.color = '#f44e4e';
    }
    const value = Number(Math.abs(amount)).toFixed(2);
    return <span title={`${isNegative ? '-' : ''} $ ${value}`}>
        {isNegative ? '-' : ''}{currency ? currency : '$'} {value}
    </span>;
};


export default Money;